import { connect } from "react-redux";

import { setBackdrop } from "../../../actions/appEngine";
import { setUser } from "../../../actions/user";
import {
	createAutoAssignCarrier,
	createDisableCarrier,
	deleteAutoAssignCarrier,
	deleteDisableCarrier,
	getAllModeLists,
	getAutoAssignCarrier,
	getUserCarriers,
	optSecureShipment,
	updateAutoAssignCarrier,
} from "../../../apilist";
import DisableCarriers from "../components/DisableCarriers";
import SetRulesCarriers from "../components/SetRules";

const mapDispatchToProps = {
	optSecureShipment,
	setBackdrop,
	setUser,
	getUserCarriers,
	createDisableCarrier,
	deleteDisableCarrier,
	getAutoAssignCarrier,
	updateAutoAssignCarrier,
	createAutoAssignCarrier,
	deleteAutoAssignCarrier,
	getAllModeLists,
};

const mapStateToProps = (state) => ({
	user: state.user,
	appEngine: state.appEngine,
	pickup: state.pickup,
});

const containerCreator = connect(mapStateToProps, mapDispatchToProps);

export const Carriers = containerCreator(DisableCarriers);
export const CarriersRules = containerCreator(SetRulesCarriers);
